var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeLapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 500,
    viewBox: "0 0 360 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gtl",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4facfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00f2fe"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 500,
    fill: "url(#gtl)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.2)",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,250 C90,230 180,270 270,250 C315,240 360,260 360,260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,300 C90,280 180,320 270,300 C315,290 360,310 360,310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,350 C90,330 180,370 270,350 C315,340 360,360 360,360"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLapse);
export default __webpack_public_path__ + "static/media/time-lapse.8b06163a4525ee4e37a6d034e1451831.svg";
export { ForwardRef as ReactComponent };